// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class ListView extends JQueryView {
  constructor() {
    super('.documents-table');
  }

  @on({ event: 'click', selector: 'tr[data-href]' })
  onClickTr(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.location = $(e.currentTarget).data('href');
  }
}
